import { render, staticRenderFns } from "./CustomerWeightTracking.vue?vue&type=template&id=3f315042&scoped=true&"
import script from "./CustomerWeightTracking.vue?vue&type=script&lang=js&"
export * from "./CustomerWeightTracking.vue?vue&type=script&lang=js&"
import style0 from "./CustomerWeightTracking.vue?vue&type=style&index=0&id=3f315042&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f315042",
  null
  
)

export default component.exports